import { render, staticRenderFns } from "./BiologicalWarningInfo.vue?vue&type=template&id=42c93b86"
import script from "./BiologicalWarningInfo.vue?vue&type=script&lang=js"
export * from "./BiologicalWarningInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports